const { h } = window.preact;
const html = window.htm.bind(h);

export function Spinner({ size = "md" }) {
  const sizeClasses = {
    md: "w-4 h-4",
    md: "w-6 h-6",
    lg: "w-8 h-8"
  };

  return html`
    <div class="flex justify-center items-center">
      <div 
        class=${`animate-spin rounded-full border-2 border-[#6B8E23] border-t-transparent ${sizeClasses[size]}`}
        role="status"
        aria-label="Loading"
      >
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  `;
} 